import React from 'react';
import styled from "styled-components";
import {getImage} from "../../../utils/utils";
import accountSVG from "../../../images/account.svg";

const PilotCard = ({
                       firstName,
                       id,
                       lastName,
                       picture,
                       selectedPilot
                   }) => {

    return (
        <Card className={selectedPilot === id ? "user-selected" : ""}>
            <ContainerImage>
                <img src={getImage(picture, accountSVG)} alt={firstName}/>
            </ContainerImage>
            <p> {firstName === "Deleted" ? "Utilisateur supprimé" : firstName} {lastName === "User" ? "" : lastName} </p>
        </Card>
    )
}

const Card = styled.div`
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-width: 4em;
  max-width: 4em;
  margin: 0.2em;
  cursor: pointer;
  padding: 0.5em;
  :hover {
    background: var(--color-purple-lighten);
  }
`

const ContainerImage = styled.div`
  display: flex;
  align-items: center;
  min-width: 40px;
  max-width: 40px;
  min-height: 40px;
  max-height: 40px;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`
export default PilotCard;